export default __webpack_public_path__ + "static/media/docxfile.aef33788.svg";